import { FaAngleDown } from "react-icons/fa6";
import cssVars from "../styles/cssVariables.vars";

const defaultInput100 = {
    $color: cssVars.colorGrey[4],
    $borderColor: cssVars.colorGrey[5],
    $padding: [0.5, 0.75] as [number, number],
    $focusColor: cssVars.colorGrey[2],
    $fontSize: 0.875,
    $width: "100%",
    leftIcon: null,
    rightIcon: null,
}

const defaultInput50 = {
    ...defaultInput100,
    $width: "calc(50% - 0.5rem)"
}

const defaultSelect100 = {
    ...defaultInput100,
    $focusColor: cssVars.colorGrey[2],
    leftIcon: null,
    rightIcon: <FaAngleDown />,
}

const defaultSelect50 = {
    ...defaultSelect100,
    $width: "calc(50% -0.5rem)"
}

export { defaultInput100, defaultInput50, defaultSelect100, defaultSelect50 };